import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { selectWorks } from '../../../Api/selectors';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { KanbanExtraCostsWrapper } from '../../components/KanbanExtraCostsWrapper';
import { VehiclePhotoUploader } from '../../../Vehicles/components/VehiclePhotoUploader';
import { selectVehicle } from '../../../Vehicles/selectors';
import { Row } from '../../../../components/List';
import { VehicleEditableField } from '../../../Vehicles/components/VehicleEditableField';

const Container = styled.div``;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_poetsenComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  get vehicle() {
    return this.props.cell.vehicle;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={this.vehicle} />

        <Row>
          <Cell>
            <VehicleEditableField name={'HOOI_poetsen_comment'} inputType={'textarea'} vehicle={this.props.vehicle} />
          </Cell>
        </Row>

        <VehiclePhotoUploader
          vehicle={this.props.vehicle}
          photoType={'HOOI_NEW_poetsen'}
          photoIndex={'photo_hooi_hooi_instalation'}
          imageHeight={'250px'}
        />
        <KanbanExtraCostsWrapper vehicleId={this.vehicle?.id} />

        <ModalControls>
          <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle?.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_poetsenComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_poetsen = compose(withConnect, withRouter)(HOOI_poetsenComp);
